const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';
const TOKEN_KEY = 'owl_token';
export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    }
    catch {
        return null;
    }
}
export function setToken(token) {
    try {
        localStorage.setItem(TOKEN_KEY, token);
    }
    catch {
        // localStorage not available (e.g. in some WebView contexts)
    }
}
export function removeToken() {
    try {
        localStorage.removeItem(TOKEN_KEY);
    }
    catch {
        // ignore
    }
}
export async function apiFetch(path, options = {}) {
    const token = getToken();
    const headers = new Headers(options.headers);
    if (!headers.has('Content-Type') && options.body) {
        headers.set('Content-Type', 'application/json');
    }
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    const response = await fetch(`${API_BASE_URL}${path}`, {
        ...options,
        headers,
    });
    if (response.status === 401) {
        removeToken();
        // Dispatch a custom event so AuthContext can react
        window.dispatchEvent(new CustomEvent('owl:auth-expired'));
    }
    return response;
}
/**
 * Convenience: makes an API call and parses JSON response.
 * Throws on non-ok responses.
 */
export async function apiFetchJson(path, options = {}) {
    const response = await apiFetch(path, options);
    return response.json();
}
//# sourceMappingURL=api.js.map